(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelector('#system-message-container')) {
            return
        }

        new BSN.Modal(
          '#system-message-container'
        ).show()
    })
}) ()

